import React, { useContext, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import { Col, Container, Row } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';

const Employdetailmodal = props => {
    return (
        <div dir='rtl'>
            <Modal
                show={props.show}
                onHide={() => props.setshow(false)}
                dialogClassName="modal-100w"
                aria-labelledby="example-custom-modal-styling-title"
                size="lg"
            >
                <Modal.Body>
                    <Row className="justify-content-md-center mt-4" dir='rtl'>
                        <Col lg={5}>
                            <Form.Group controlId="formBasicName">
                                <Form.Label>ناو</Form.Label>
                                <Form.Control type="text" placeholder="ناو" value={props.lis.employ_name} disabled />
                            </Form.Group>
                        </Col>
                        <Col lg={5}>
                            <Form.Group controlId="formBasicName">
                                <Form.Label>ئیمەیڵ</Form.Label>
                                <Form.Control type="text" placeholder="ئیمەیڵ" value={props.lis.employ_email} disabled />
                            </Form.Group>
                        </Col>
                        <Col lg={5}>
                            <Form.Group controlId="formBasicName">
                                <Form.Label>بڕوانامە</Form.Label>
                                <Form.Control type="text" placeholder="بڕوانامە" value={props.lis.certificate_name} disabled />
                            </Form.Group>
                        </Col>
                        <Col lg={5}>
                            <Form.Group controlId="formBasicName">
                                <Form.Label>شوێن</Form.Label>
                                <Form.Control type="text" placeholder="شوێن" value={props.lis.department_name} disabled />
                            </Form.Group>
                        </Col>
                        <Col lg={5}>
                            <Form.Group controlId="formBasicName">
                                <Form.Label>ژمارە تەلەفۆن </Form.Label>
                                <Form.Control type="text" placeholder="ژمارە تەلەفۆن " value={props.lis.employ_phone1} disabled />
                            </Form.Group>
                        </Col>
                        <Col lg={5}>
                            <Form.Group controlId="formBasicName">
                                <Form.Label>پیشە</Form.Label>
                                <Form.Control type="text" placeholder="پیشە" value={props.lis.employ_job} disabled />
                            </Form.Group>
                        </Col>
                        <Col lg={5}>
                            <Form.Group controlId="formBasicName">
                                <Form.Label>موچە</Form.Label>
                                <Form.Control type="text" placeholder="موچە" value={props.lis.employ_salary + "IQD"} disabled />
                            </Form.Group>
                        </Col>
                        <Col lg={5}>
                            <Form.Group controlId="formBasicName">
                                <Form.Label>بەشەوانە</Form.Label>
                                <Form.Control type="text" placeholder="بەشەوانە" value={props.lis.lesson_part} disabled />
                            </Form.Group>
                        </Col>
                        <Col lg={5}>
                            <Form.Group controlId="formBasicName">
                                <Form.Label>خزمەت</Form.Label>
                                <Form.Control type="text" placeholder="خزمەت" value={props.lis.employ_service_amount + "IQD"} disabled />
                            </Form.Group>
                        </Col>
                        <Col lg={5}>
                            <Form.Group controlId="formBasicName">
                                <Form.Label>کۆمیشنی ڕێککەوتن</Form.Label>
                                <Form.Control type="text" placeholder="کۆمیشنی ڕێککەوتن" value={props.lis.employ_agrement_amount + "IQD"} disabled />
                            </Form.Group>
                        </Col>
                        <Col lg={10}>
                            <Form.Group controlId="formBasicName">
                                <Form.Label>تێبینی</Form.Label>
                                <Form.Control type="text" placeholder="تێبینی" value={props.lis.employ_note} disabled />
                            </Form.Group>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="dark" onClick={() => {
                        props.setshow(false);
                    }}>
                        داخستن
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default Employdetailmodal